<div @fade class="stats-container">
  <div class="information-container">
    <div class="container-text">
      <h1>Mis Estadísticas</h1>
    </div>
  </div>
  <div class="left">
    <div class="evolution-text">
      <h2>Esta ha sido tu evolución durante los últimos 12 meses.</h2>
    </div>
    <div class="tab-selection">
      <div class="tab-container">
        <div class="tab-1" [ngClass]="{'current-tab': currentTab === 1}" (click)="changeGraphicView(1)">Vista
          Mensual</div>
        <div class="tab-2" [ngClass]="{'current-tab': currentTab === 2}" (click)="changeGraphicView(2)">Vista
          Acumulada</div>
      </div>
    </div>
    <div class="canvas-container">
      <div class="scroll-container">
        <canvas id="myChart"></canvas>
      </div>
    </div>
  </div>
  <div class=" right">
    <div class="cards-container">
      <div class="cards-tittle">
        <div class="tittle">
          <h3>Media</h3>
        </div>
        <div class="tittle">
          <h3>Max.</h3>
        </div>
        <div class="tittle">
          <h3>Min.</h3>
        </div>
      </div>
      <div class="card" *ngFor="let item of cards">
        <h3>{{item.name}}</h3>
        <div class="column-cards">
          <div class="c" *ngFor="let i of item.values; let ind = index">
            <div class="media" *ngIf="ind === 0">
              <span class="media-tittle">MEDIA</span>
              <p class="value">{{(i.value | number:'1.0' )+ '€'}}</p>
            </div>
            <div class="min-max" *ngIf="i.value.month">
              <span class="tittle">{{i.value.valor}}</span>
              <div class="content">
                <p class="month">{{i.value.month}}</p>
                <p class="value">
                  {{ (i.value.value | number:'1.0') + '€'}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading-akana *ngIf="showLoading"></app-loading-akana>
